// extracted by mini-css-extract-plugin
module.exports = {"tag__wrapper":"styles_tag__wrapper__10tR1"};